import "core-js/modules/es.array.join.js";
/* eslint-disable react/prop-types */
import React from 'react';
import { makeStyles, Box } from '@applyboard/ui-components';
var useStyles = makeStyles({
  mockWidget: {
    alignItems: 'center',
    backgroundColor: '#0064e2',
    borderRadius: '25px',
    color: 'white',
    display: 'flex',
    fontSize: '12px',
    height: '50px',
    justifyContent: 'center',
    overflow: 'visible',
    pointerEvents: 'auto',
    width: '146px'
  },
  mockWidgetFloating: {
    margin: '10px 20px',
    position: 'fixed',
    bottom: '0px',
    overflow: 'visible',
    pointerEvents: 'auto',
    zIndex: 99,
    // allow real Zendesk widget to go on top with its zIndex 100
    right: '0px'
  }
});
function shouldHideMock() {
  return window.ENVIRONMENT === 'production';
}
export var MockZendeskWidget = function MockZendeskWidget(_ref) {
  var _ref$floating = _ref.floating,
    floating = _ref$floating === void 0 ? true : _ref$floating;
  var classes = useStyles();
  if (shouldHideMock()) {
    return /*#__PURE__*/React.createElement("div", {
      "aria-hidden": true,
      style: {
        height: 50,
        width: 1
      }
    }, "\xA0");
  }
  return /*#__PURE__*/React.createElement(Box, {
    id: "mock-zendesk-widget",
    className: floating ? [classes.mockWidget, classes.mockWidgetFloating].join(' ') : classes.mockWidget
  }, "mock chat widget");
};